<template>
  <v-content>
    <v-dialog v-model="showEula"
              max-width="60%"
              :fullscreen="$vuetify.breakpoint.xs">
      <v-card v-if="showEula">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>Terms of Service</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout column v-if="eula" style="white-space: pre-line" my-4>
            <div class="subtitle-2 black--text">
              <span>By signing up to this service, you:</span>
              <ol>
                <li>Confirm you are 18 years or older AND</li>
                <li>Give permission for your information to be shared with trusted business partners and organisations</li>
              </ol>
            </div>
            {{eula}}
          </v-layout>
          <v-layout pa-12 align-center justify-center v-else>
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-layout>
          <v-layout v-if="eula" mt-4>
            <v-btn color="primary" @click="showEula = false">Close</v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPrivacyPolicy"
              max-width="60%"
              :fullscreen="$vuetify.breakpoint.xs">
      <v-card v-if="showPrivacyPolicy">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>Privacy Policy</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout v-if="privacyPolicy" style="white-space: pre-line">
            {{privacyPolicy}}
          </v-layout>
          <v-layout pa-12 align-center justify-center v-else>
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-layout>
          <v-layout v-if="privacyPolicy" mt-4>
            <v-btn color="primary" @click="showPrivacyPolicy = false">Close</v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container>
      <v-layout column text-center wrap align-content-center justify-center>
        <v-card width="700">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Create an account!</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-4">
            <div>
              <v-alert v-if="error"
                       border="bottom"
                       colored-border
                       type="error">
                {{ error }}
              </v-alert>
              <v-form v-model="valid" ref="form" lazy-validation autocomplete="on">
                <v-text-field label="Name"
                              v-model="name"
                              :rules="nameRules"
                              required
                              filled></v-text-field>
                <v-text-field type="email"
                              label="Email"
                              v-model="email"
                              :rules="emailRules"
                              required
                              filled></v-text-field>
                <v-text-field label="Password"
                              v-model="password"
                              min="8"
                              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                              @click:append="showPassword = !showPassword"
                              :type="showPassword ? 'text' : 'password'"
                              :rules="passwordRules"
                              counter
                              required
                              filled></v-text-field>
                <v-layout align-center text-left class="agreement" mb-3>
                  <v-checkbox v-model="agreed" :rules="agreementRules" id="eula-box"></v-checkbox>
                  <label for="eula-box">
                    By checking this box, I acknowledge I am 18 years or older and I have read, understand and agree to the
                    <a @click.prevent="getEula()">Terms of Service</a> and the <a @click.prevent="getPrivacyPolicy()">Privacy Policy</a>
                  </label>
                </v-layout>
                <v-layout justify-space-between>
                  <router-link to="login">Already have an account?</router-link>
                  <v-btn type="submit" @click.prevent="submit" :disabled="!valid" :class=" { 'blue darken-4 white--text' : valid, disabled: !valid }">Sign Up</v-btn>
                </v-layout>
              </v-form>
            </div>
          </v-card-text>
          <v-progress-linear indeterminate :active="showLoading"></v-progress-linear>
        </v-card>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
  import axios from "../plugins/axios"

  export default {

    data() {
      return {
        valid: false,
        showLoading: false,
        error: '',
        showPassword: false,
        password: '',
        passwordRules: [
          v => !!v || 'Password is required',
        ],
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'That doesn\'t look like a real email address',
        ],
        name: '',
        nameRules: [
          v => !!v || 'Name is required'
        ],
        agreed: false,
        agreementRules: [
          v => v || 'You must agree to these conditions before signing up'
        ],
        showEula: false,
        eula: null,
        showPrivacyPolicy: false,
        privacyPolicy: null,
      }
    },
    methods: {
      submit() {
        if (this.$refs.form.validate()) {
          this.showLoading = true;
          axios.post("api/auth/create", { email: this.email, password: this.password, name: this.name, phoneNumber: null })
            .then(res => {
              this.$store.commit("setUser", res.data);
              this.$router.push("/")
            })
            .catch(e => {
              this.showLoading = false;
              if (e && e.response && e.response.data && e.response.data.message)
                this.error = e.response.data.message;
              else
                this.error = "Something went wrong. Please make sure your email is valid and try again";
            })
        }
      },
      clear() {
        this.$refs.form.reset()
      },
      getEula() {
        this.showEula = true;
        if (!this.eula) {
          axios.get("/subscription/assets/eula.txt", { responseType: 'text' }).then(x => this.eula = x.data);
        }
      },
      getPrivacyPolicy() {
        this.showPrivacyPolicy = true;
        if (!this.privacyPolicy) {
          axios.get("/subscription/assets/privacy.txt", { responseType: 'text' }).then(x => this.privacyPolicy = x.data);
        }
      }
    },
  };
</script>
<style scoped>
  .agreement a {
    margin: 0 5px;
    text-decoration:underline;
    font-weight:600;
  }
  .agreement {
    font-size: 1.15em;
  }
  .agreement .v-input {
    margin-bottom: -6px;
  }
  label[for='eula-box'] a {
    font-size:1.1em;
  }
</style>
